// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
  
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();




import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './WebSocketContext';
import AutomationBlocked from './components/AutomationBlocked';
import {
  isAutomatedBrowser,
  isAutomationBlockPersisted,
  persistAutomationBlock,
  clearAutomationBlock,
  reportAutomationDetection,
  watchForAutomation,
} from './utils/automationGuard';
import { initTradeDeviceMeta } from './utils/tradeDeviceMeta';

const root = ReactDOM.createRoot(document.getElementById('root'));

function renderBlocked() {
  persistAutomationBlock();
  root.render(<AutomationBlocked />);
}

function renderApp() {
  try {
    const userId = localStorage.getItem('userId');
    if (userId) {
      initTradeDeviceMeta({ clientId: userId, prefetchFcm: true });
    }
  } catch {
    // ignore storage errors
  }

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
  watchForAutomation(() => {
    applyAutomationGuard(true);
  });
}

async function applyAutomationGuard(detectedNow) {
  const persisted = isAutomationBlockPersisted();
  if (!detectedNow && !persisted) {
    renderApp();
    return;
  }

  if (persisted) {
    root.render(<AutomationBlocked />);
  }

  const result = await reportAutomationDetection();
  if (result.enabled === false) {
    clearAutomationBlock();
    renderApp();
    return;
  }

  renderBlocked();
}

applyAutomationGuard(isAutomatedBrowser());

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
